import {FormField} from "../form-field/form-field";
import {GvfService} from "../../../gvf/js/gvf-service";

export class FormFieldMultiselect extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$select = null;
        this.orderedValue = null;
    }

    getVal(){
        return this.$select.val();
    }

    setVal(val,noEvent){
        this.$select.val(val);
        this.$select.multiSelect("refresh");
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$select = this.$root.find(this.scope+"__select");
        this.orderedValue = this.$root.data("ordered-value");
        this.$search = this.findMember("search");
        if(this.orderedValue){ //reorder options to keep original order
            for(let i = this.orderedValue.length; i>=0; i--){
                this.$select.find("[value='"+this.orderedValue[i]+"']").prependTo(this.$select);
            }
        }
        this.$select.multiSelect(
            {
                keepOrder: true,
                afterSelect: ()=>{
                    //options indexed by text
                    const options = [];
                    this.$select.find("option").each(
                        (index,item)=>{
                            options[$(item).text()] = $(item);
                        }
                    );

                    //reorder options to keep order
                    this.$root.find(".ms-elem-selection").each(
                        (index,item)=>{
                            if(options[$(item).text()]){
                                options[$(item).text()].appendTo(this.$select);
                            }
                        }
                    );
                }
            }
        );

        this.$search.keyup(
            ()=>{
                if(this.$search.val()==""){
                    this.$root.find(".ms-elem-selectable:not(.ms-selected)").show();
                }else{
                    GvfService.delay(500,"checksearch").then(
                        ()=>{
                            const s = this.$search.val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                            this.$root.find(".ms-elem-selectable:not(.ms-selected)").each(
                                (index,item)=>{
                                    const t = $(item).text().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                                    $(item).toggle(t.indexOf(s)>-1);
                                }
                            );
                        }
                    );
                }
            }
        );
    }
}

